import makeStyles from '@mui/styles/makeStyles';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import React from 'react';
import { grey } from '@mui/material/colors';

const useStyles = makeStyles(theme => ({
  menuRadioIcon: {
    marginRight: '8px',
  },
}));

interface IRadioImpersonatorIcon {
  checked: boolean;
}

const RadioImpersonatorIcon = (props: IRadioImpersonatorIcon) => {
  const classes = useStyles();

  return (
    <>
      {props.checked ? (
        <RadioButtonCheckedIcon
          color="primary"
          className={classes.menuRadioIcon}
        />
      ) : (
        <RadioButtonUncheckedIcon
          className={classes.menuRadioIcon}
          style={{ color: grey[600] }}
        />
      )}
    </>
  );
};
export default RadioImpersonatorIcon;
